module.exports = __webpack_public_path__ + "img/label_nodata.e481eba5.svg";